<template>
  <v-row justify="center">
    <v-dialog v-model="createDialog" persistent scrollable max-width="700px">
      <v-card>
        <v-card-title>
          <v-col cols="12" sm="8" style="min-width: 100%;">
            <h2>{{ title }}</h2>
            <v-select
              label="Select A Payment Request Type"
              v-model="selectedPaymentRequest"
              :items="paymentRequestTypes"
              item-value="value"
              item-text="text"
            >
              <template v-slot:item="{ item, attrs, on }">
                <v-list-item v-bind="attrs" v-on="on">
                  <v-list-item-content>
                    <v-list-item-title
                      :id="`${item.value}-option`"
                      v-text="item.text"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </v-col>
        </v-card-title>
        <v-card-text class="pb-0 create-payment">
          <StandardPaymentRequest
            v-if="
              selectedPaymentRequest == 'standard' &&
                canCreateStandardPaymentRequest
            "
          />
          <RecurringPaymentRequest
            v-if="
              selectedPaymentRequest == 'recurring' &&
                canCreateRecurringPaymentRequest
            "
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey darken-1" text @click="closeModal">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import StandardPaymentRequest from "@/views/pages/merchant/paymentrequest/StandardPaymentRequest.vue";
import RecurringPaymentRequest from "@/views/pages/merchant/paymentrequest/RecurringPaymentRequest.vue";
import PaymentRequestPerimissionsMixin from "@/components/paymentrequest/PaymentRequestPermissionsMixin.js";

export default {
  mixins: [PaymentRequestPerimissionsMixin],
  components: {
    StandardPaymentRequest,
    RecurringPaymentRequest
  },
  props: {
    createDialog: Boolean,
    value: String
  },
  data() {
    return {};
  },
  computed: {
    selectedPaymentRequest: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    title() {
      if (this.selectedPaymentRequest == "standard")
        return "Standard Payment Request";
      if (this.selectedPaymentRequest == "recurring")
        return "Recurring Payment Request";

      return "Create A Payment Request";
    },
    paymentRequestTypes() {
      let allowedOperation = [];
      if (this.canCreateStandardPaymentRequest)
        allowedOperation.push({ text: "Standard", value: "standard" });
      if (this.canCreateRecurringPaymentRequest)
        allowedOperation.push({ text: "Recurring", value: "recurring" });
      return allowedOperation;
    }
  },
  methods: {
    closeModal() {
      this.$emit("eCloseCreatePaymentRequestModal");
    }
  }
};
</script>

<style>
.create-payment > .container > form > .container > .row {
  display: flex;
  flex-direction: column;
}

.create-payment > .container > form > .container > .row > * {
  max-width: 100% !important;
}

.form-group {
  margin-bottom: 0;
}
.form-group > label {
  font-weight: 700;
  color: black;
}

#currency_parent {
  display: flex;
  justify-content: center;
  max-width: 100%;
  margin: 0%;
}
#currency_input {
  padding-right: 0;
  min-width: 70%;
  max-width: 70%;
}

#currency_select {
  padding-left: 0;
  min-width: 30%;
  max-width: 30%;
}
.input-group-prepend > .pr-0 {
  padding-right: 0 !important;
}

#date__container {
  display: flex;
  flex-direction: row;
}
#date__container:last-child {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

form > .pb-0 {
  padding-left: 12px !important;
}
</style>
